// src/pages/in-kind/RequestCrop.js
import InKindForm from "../../components/InKindForm";

function RequestCrop() {
  return <InKindForm contributionType="need" />;
}

export default RequestCrop;